import { render, staticRenderFns } from "./InactiveEmployeeIndex.vue?vue&type=template&id=fa09622e&scoped=true&"
import script from "./InactiveEmployeeIndex.vue?vue&type=script&lang=js&"
export * from "./InactiveEmployeeIndex.vue?vue&type=script&lang=js&"
import style0 from "./InactiveEmployeeIndex.vue?vue&type=style&index=0&id=fa09622e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa09622e",
  null
  
)

export default component.exports